import React, { useEffect, useState, useContext, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import { _t, getCookie , } from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KdsModal from "./KdsModal";

//importing context consumer here
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { FoodContext } from "../../../../contexts/Food";
import {SettingsContext} from "../../../../contexts/Settings";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import KdsHeader from "./component/KdsHeader";

const KitchenTakeaway = () => {
  const { t } = useTranslation();
  //getting context values here

  const {
    //kitchen dashboard
    getKitchenNewOrders,
    kithcenNewOrders,
    setKithcenNewOrders,
    kdsListForSearch,
    loading,
    setLoading,
  } = useContext(RestaurantContext);

  const {
    //food group
    foodGroupForSearch,
  } = useContext(FoodContext);

  //state hooks
  const [filterOrder, setFilterOrder] = useState({
    isFiltered: false,
    filterKey: "",
    groups: null,
  });
  
  //search result
  const [searchedOrder, setSearchedOrder] = useState({
    list: null,
    searched: false,
  });
  const [readyOrderCounter, setReadyOrderCounter] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [itemData, setItemData] = useState({
    url:"",
    name: "", 
    token: ""  
  });
  const orderReady = useRef();
  const refresh = useRef();

  useEffect(() => {
    //get all orders when coming to kithcen
    getKitchenNewOrders("Delivery,Takeaway");

    //add "All" option to group filter
    let tempFoodGroups = [];
    foodGroupForSearch &&
      foodGroupForSearch.map((item) => {
        if (item.name !== "All") {
          tempFoodGroups.push(item);
        }
      });
    //new option added to food group
    tempFoodGroups.unshift({ name: "All" });
    setFilterOrder({
      ...filterOrder,
      groups: tempFoodGroups,
    });
  }, [foodGroupForSearch]);

  //filter ordered items
  const handleFilter = (foodGrp) => {
    setFilterOrder({
      ...filterOrder,
      isFiltered: foodGrp.name == "All" ? false : true,
      filterKey: foodGrp.name,
    });
  };

  //search orders here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedOrder({ ...searchedOrder, searched: false });
    } else {
      let searchedList =
        kithcenNewOrders &&
        kithcenNewOrders.filter((item) => {
          //token
          let lowerCaseItemToken = item.token?.id.toLowerCase();
          return lowerCaseItemToken.includes(searchInput);
        });
      setSearchedOrder({
        ...searchedOrder,
        list: searchedList,
        searched: true,
      });
    }
  };

  // image pop up
  const handleOpenPopup = (item,token) => {
    setItemData({
      url: BASE_URL + item?.order_image,
      name: item.food_group + " - " + item.food_item,
      token: `Order Token: ${token}`,
    })
    setIsOpen(true);
  };

  const handleClosePopup = () => {
    setIsOpen(false);
  };

  // kitchen bell ring
  useEffect(()=>{
    setTimeout(() => {    
      kithcenNewOrders && setReadyOrderCounter(kithcenNewOrders?.length);
    }, 200);
  },[kithcenNewOrders]);
  
  orderReady.current = readyOrderCounter;
  refresh.current = kithcenNewOrders?.length;
 
  useEffect(() => {
    const interval = setInterval(() => {
      const url = BASE_URL + "/settings/get-new-orders/Delivery,Takeaway";
      setLoading(true)
      return axios
          .get(url, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setKithcenNewOrders(res.data[0]);
            localStorage.setItem(url, JSON.stringify(res));
            // let newOrder = orderReady.current;
            if(res.data[1] === 1){
              let beep = document.getElementById("myAudioPhoneRing");
              beep.play().catch(()=>{});
            }
            setReadyOrderCounter(res.data[0]?.length);
            setLoading(false)
          })
        .catch((err) => {
        setLoading(false)
        })
    }, 22000);
    return () => {
      clearInterval(interval);
    };
    
  }, []);
  
  //accept or reject
  const handleAcceptOrReject = (id) => {
    setLoading(true);
    const url = BASE_URL + "/settings/kitchen-order-status";
    let formData = {
      id,
      status:"TA"
    };
  
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then(() => {
        //remove ready item from order list
        getKitchenNewOrders("Delivery,Takeaway");
        let newState = kithcenNewOrders.filter((orderItem) => {
          return orderItem.id !== id;
        });
        setReadyOrderCounter(newState?.length);
        //remove ready item from search list
        if (searchedOrder.searched) {
          setSearchedOrder({ ...searchedOrder,list: newState, searched: false })
        }
        setLoading(false);
        
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please refresh and try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });

      });
  };

  const renderItem = (item,thisItem,indexThisItem,del=false) =>{
    return(
      <div className={`row g-0 ${del ? "text-decoration-line-through text-danger" : ""}`}>
        <div className="col-1 text-center border-right d-flex py-2">
          <span className="fk-addons-table__info-text text-capitalize m-auto">
            {indexThisItem + 1}
          </span>
        </div>
        <div className="col-4 text-center border-right d-flex py-2">
          <span className="fk-addons-table__info-text text-capitalize m-auto">
            {thisItem.food_item} 
            <div className="font-weight-md">({thisItem.food_group})</div>
          </span>
        </div>
        <div className="col-4 text-center border-right px-2 py-2">
          {thisItem.variation !==
            null && (
            <span className="fk-addons-table__info-text text-capitalize d-block text-left t-pt-5">
              <span className="font-weight-bold mr-1">
                {_t(t("variation"))}:
              </span>
              {thisItem.variation}
            </span>
          )}

          {thisItem.properties !==
            null && (
            <span className="fk-addons-table__info-text text-capitalize d-block text-left ">
              <span className="font-weight-bold mr-1">
                {_t(t("properties"))}:
              </span>
              {JSON.parse(
                thisItem.properties
              ).map(
                (
                  propertyItem,
                  thisIndex
                ) => {
                  if (
                    thisIndex !==
                    JSON.parse(
                      thisItem.properties
                    ).length -
                      1
                  ) {
                    return (
                      propertyItem.property +
                      ", "
                    );
                  } else {
                    return propertyItem.property;
                  }
                }
              )}
            </span>
          )}
          {thisItem.comments !==
            null && (
            <span className="fk-addons-table__info-text text-capitalize d-block text-left t-pb-5">
              <span className="font-weight-bold mr-1">
                {_t(t("instruction"))}:
              </span>
              {thisItem?.comments}
            </span>
          )}
          
        </div>
        <div className="col-2 text-center border-right d-flex py-2">
          <span className="fk-addons-table__info-text text-capitalize font-weight-md m-auto">
            {thisItem.quantity}
          </span>
        </div>
        <div className="col-1 text-center border-right py-2">
          {
            !del && thisItem?.order_image && (
              <div className="text-center cursor-pointer xslg-text" onClick={()=>handleOpenPopup(thisItem,item.token?.id)}><i className="fa fa-eye"></i></div>
            )
          }
        </div> 
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Kitchen"))}</title>
      </Helmet>
      <main id="main" data-simplebar>
        <div className="fk-scroll--index t-mt-15 t-mb-15" data-simplebar>
          <div className="container-fluid">
            <div className="t-bg-white t-pt-10 t-pb-10 t-pl-15 t-pr-15">
              {/* next page data spin loading */}
              <CustomSpinLoader loading={loading}/>
              {/* spin loading ends */}
              <KdsModal
                show= {isOpen}
                handleClose= {handleClosePopup}
                itemData= {itemData}
              />
              <KdsHeader
                name = "Delivery/Takeway"
                apiEndpoint="Delivery,Takeaway"
                refresh={refresh}
                orderReady={orderReady}
                setReadyOrderCounter={setReadyOrderCounter}
                setSearchedOrder={setSearchedOrder}
                filterOrder={filterOrder}
                handleFilter={handleFilter}
              />
            </div>
            {!searchedOrder.searched ? (
              <div className="row no-gutters g-4 mt-1">
                {kithcenNewOrders ? (
                  [
                    kithcenNewOrders.length > 0 ? (
                      kithcenNewOrders.map((item, index) => {
                        const kdsTimeColor = kdsListForSearch && kdsListForSearch.find((item)=> item.name === "Takeaway");
                        let bgColor = "";   
                        const dateTimeAgo = item.token?.time;
                        // Calculate the Unix timestamp for time1 minutes ago
                        const fiveMinutesAgoTimestamp = moment().subtract(kdsTimeColor?.time_1, 'minutes').valueOf();
                        // Calculate the Unix timestamp for time2 minutes ago
                        const tenMinutesAgoTimestamp = moment().subtract(kdsTimeColor?.time_2, 'minutes').valueOf();
                        if (dateTimeAgo > fiveMinutesAgoTimestamp) {
                          bgColor = kdsTimeColor.time_color_1
                        } else if (dateTimeAgo > tenMinutesAgoTimestamp) {
                          bgColor = kdsTimeColor.time_color_2
                        }else if(kdsTimeColor?.time_1 && kdsTimeColor?.time_2){
                          bgColor="#fa4851"
                        }

                        return (
                          <div
                            className="col-md-6 col-lg-4 col-xl-3"
                            data-category={index + 1}
                          >
                            <div className="fk-order-token kitchen_order t-bg-white p-2 h-100">
                              <div className="fk-order-token__footer d-flex align-items-center justify-content-between">
                                { item.order_type_name ?
                                  <div className="text-capitalize">
                                    {item.order_type_name}
                                  </div>
                                  : ""
                                }
                               
                                {/* {parseInt(item.is_accepted) === 0 && ( */}
                                  <button
                                    type="button"
                                    className="btn btn-success xsm-text text-uppercase btn rounded"
                                    onClick={() =>
                                      handleAcceptOrReject(item.id)
                                    }
                                  >
                                    {_t(t("Accept order"))}
                                  </button>
                                {/* // )} */}
                              </div>
                              <div className="fk-order-token__body">
                                <div className="fk-addons-table">
                                  <div className="fk-addons-table__head d-flex justify-content-between px-2" style={{backgroundColor: bgColor}}>
                                    <span>
                                      {_t(t("order token"))}: #{item.token?.id}
                                    </span>
                                    <div className="d-flex flex-column justify-content-end align-items-end">
                                        <div>
                                          {/* {_t(t("ordered at"))}:{" "} */}
                                          <Moment format="LT">
                                            {item.token?.time}
                                          </Moment>
                                        </div>
                                        <div style={{fontSize:"12px"}}>
                                          <Moment fromNow>
                                            {item.token?.time}
                                          </Moment>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="fk-addons-table__info">
                                    <div className="row g-0">
                                      <div className="col-1 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("S/L"))}
                                        </span>
                                      </div>
                                      <div className="col-4 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("food"))}
                                        </span>
                                      </div>
                                      <div className="col-4 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("Additional Info"))}
                                        </span>
                                      </div>
                                      <div className="col-2 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("QTY"))}
                                        </span>
                                      </div>
                                      <div className="col-1 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          <i className="fa fa-check"></i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="fk-addons-table__body">
                                    {item.orderedItems.map(
                                      (thisItem, indexThisItem) => {
                                        if (filterOrder.isFiltered) {
                                          if (
                                            thisItem.food_group ===
                                            filterOrder.filterKey
                                          ) {
                                            return (
                                              <div className="fk-addons-table__body-row">
                                                {renderItem(item,thisItem,indexThisItem)}
                                              </div>
                                            );
                                          }
                                        } else {
                                          return (
                                            <div className="fk-addons-table__body-row">
                                              {renderItem(item,thisItem,indexThisItem)}
                                            </div>
                                          );
                                        }
                                      }
                                    )}
                                    
                                    {item.orderDeleteItem.map((thisItem, indexThisItem)=>{
                                      return (
                                        <div className="fk-addons-table__body-row">
                                          {renderItem(item,thisItem,indexThisItem, true)}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-8 offset-2" data-category="1">
                        <div className="fk-order-token t-bg-white p-5 text-center text-uppercase text-primary no-order">
                          {/* No order in the kitchen */}
                          <img
                            src="/assets/img/no-order.jpg"
                            alt="no order found"
                            className="img-fluid h-100"
                          />
                        </div>
                      </div>
                    ),
                  ]
                ) : (
                  <div className="col-12" data-category="1">
                    <Skeleton
                      className="fk-order-token t-bg-white p-3 border border-2"
                      style={{ minHeight: "560px" }}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="row no-gutters g-4 mt-1">
                {searchedOrder ? (
                  [
                    searchedOrder.list.length > 0 ? (
                      searchedOrder.list.map((item, index) => {
                        return (
                          <div
                            className="col-md-6 col-lg-4 col-xl-3"
                            data-category={index + 1}
                          >
                            <div className="fk-order-token kitchen_order t-bg-white p-2 h-100">
                              <div className="fk-order-token__footer d-flex align-items-center justify-content-between">
                                { item.order_type_name ?
                                  <div className="text-capitalize">
                                    {item.order_type_name}
                                  </div>
                                  : ""
                                }
                               
                                {parseInt(item.is_accepted) === 0 && (
                                  <button
                                    type="button"
                                    className="btn btn-success xsm-text text-uppercase btn rounded"
                                    onClick={() =>
                                      handleAcceptOrReject(item.id)
                                    }
                                  >
                                    {_t(t("Accept order"))}
                                  </button>
                                )}
                              </div>
                              <div className="fk-order-token__body">
                                <div className="fk-addons-table">
                                  <div className="fk-addons-table__head d-flex justify-content-between px-2">
                                    <span>
                                      {_t(t("order token"))}: #{item.token?.id}
                                    </span>
                                    <span>
                                      {/* {_t(t("ordered at"))}:{" "} */}
                                      <Moment format="LT">
                                        {item.token?.time}
                                      </Moment>
                                    </span>
                                  </div>
                                  <div className="fk-addons-table__info">
                                    <div className="row g-0">
                                      <div className="col-2 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("S/L"))}
                                        </span>
                                      </div>
                                      <div className="col-4 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("food"))}
                                        </span>
                                      </div>
                                      <div className="col-4 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("Additional Info"))}
                                        </span>
                                      </div>
                                      <div className="col-2 text-center border-right py-2">
                                        <span className="fk-addons-table__info-text text-capitalize">
                                          {_t(t("QTY"))}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="fk-addons-table__body">
                                    {item.orderedItems.map(
                                      (thisItem, indexThisItem) => {
                                        if (filterOrder.isFiltered) {
                                          if (
                                            thisItem.food_group ===
                                            filterOrder.filterKey
                                          ) {
                                            return (
                                              <div className="fk-addons-table__body-row">
                                                {renderItem(item,thisItem,indexThisItem)}
                                              </div>
                                            );
                                          }
                                        } else {
                                          return (
                                            <div className="fk-addons-table__body-row">
                                              {renderItem(item,thisItem,indexThisItem)}
                                            </div>
                                          );
                                        }
                                      }
                                    )}

                                    {item.orderDeleteItem.map((thisItem, indexThisItem)=>{
                                      return (
                                        <div className="fk-addons-table__body-row">
                                          {renderItem(item,thisItem,indexThisItem,true)}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-8 offset-2" data-category="1">
                        <div className="fk-order-token t-bg-white p-5 text-center text-uppercase text-primary no-order">
                          {/* No order in the kitchen */}
                          <img
                            src="/assets/img/no-order.jpg"
                            alt="no order found"
                            className="img-fluid h-100"
                          />
                        </div>
                      </div>
                    ),
                  ]
                ) : (
                  <div className="col-12" data-category="1">
                    <Skeleton
                      className="fk-order-token t-bg-white p-3 border border-2"
                      style={{ minHeight: "560px" }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

      {/* beep sound */}


      </main>
    </>
  );
}

export default KitchenTakeaway